/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-13 19:39:50
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {DiskConfigDOI} from "./api/diskConfigApi";
import DiskConfigService from "./service/diskConfigService";
import './diskConfig.less';

@Component({name: 'disk-config'})
export default class DiskConfig extends BasicSearchPage<DiskConfigService, DiskConfigDOI.RowDataI, DiskConfigDOI.QueryRowDataParamsI> {

    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new DiskConfigService(this)
	}
}